module.exports = __webpack_public_path__ + "34524a47729a4d3af6644d84f247c6d5.svg";